<template>
    <div>
        <small>Selecciona rutas predeterminadas que se ajusten a los objetivos de aprendizaje</small>
        
        <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2 px-lg-5 px-md-5 px-sm-1 px-xs-1">
            <div class="justify-content-star d-flex">
                <small>
                    <strong style="color:#1A0054">
                        Mostrando {{ displayedRoutes.length }} de {{ totalRoutes }} rutas.
                    </strong>
                </small>
            </div>
            <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                <search-input-component 
                    :search="search" 
                    @onSearch="handleSearch"
                />

                <select 
                    class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                    @change="handleCategoryFilter"
                    v-model="selectedCategory"
                >
                    <option value="all">Todas las categorías</option>
                    <option 
                        v-for="category of categories" 
                        :key="category.term_id" 
                        :value="category.term_id"
                    >
                        {{ category.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="row mb-4 px-lg-5 px-md-5 px-sm-1 px-xs-1">
            <div class="col-md-4" v-for="route of displayedRoutes" :key="route.id">
                <div class="card rounded-8">
                    <img 
                        class="card-img-top" 
                        src="/images/preview_bootcamps.jpg" 
                        alt="Vista previa de ruta"
                    >
                    <div class="card-body">
                        <div class="mb-3">
                            <span class="badge badge-secondary text-primary bg-utel-v2-secondary">Ruta</span>
                        </div>
                        <div class="text-card-normal mb-3">
                            <h5 class="card-title route-title">{{ route.name }}</h5>
                            <small>
                                <i class="fa-solid fa-book-open text-primary"></i>
                                4 a 6 cursos&nbsp;|&nbsp;
                                <i class="fa-solid fa-clock text-primary"></i>
                                6 a 10 horas
                            </small>
                            <p class="card-text short-description-diploma">{{ route.description }}</p>
                        </div>
                        <ul class="text-dark small list-courses-description">
                            <li v-for="(course, index) of route.courses" :key="index">
                                <span 
                                    class="text-dark" 
                                    :title="stripHtml(course.post_content)"
                                >
                                    {{ course.post_title }}
                                </span>
                            </li>
                        </ul>
                        <div class="text-center">
                            <button 
                                class="btn bg-utel-v2-secondary text-primary sin-borde rounded-8 px-5" 
                                @click="enrollRoute(route)"
                            >
                                Inscribir ruta
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-12 text-center" v-if="showLoadMoreButton">
                <button 
                    class="btn bg-utel-v2-secondary text-primary sin-borde rounded-8 px-5" 
                    @click="loadMore"
                >
                    Ver más <i class="fa fa-chevron-down"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const ITEMS_PER_PAGE = 6;

export default {
    name: 'DefaultRoutesList',
    props: {
        categoryroutes: { type: String, required: true },
        categorysearch: { type: String, required: true },
        url_suggest_routes: { type: String, required: true },
        info: { type: Object, required: true }
    },
    emits: ['changeStep'],
    data() {
        return {
            search: '',
            categories: [],
            routes: [],
            displayedRoutes: [],
            totalRoutes: 0,
            itemsToShow: ITEMS_PER_PAGE,
            filterType: 'normal',
            selectedCategory: 'all'
        };
    },
    computed: {
        showLoadMoreButton() {
            return this.totalRoutes > this.itemsToShow && 
                   this.filterType === 'normal';
        }
    },
    mounted() {
        this.loadRoutes();
        this.loadCategories();
    },
    methods: {
        async loadRoutes() {
            try {
                const { data } = await axios.get(this.url_suggest_routes);
                this.routes = data.data;
                this.totalRoutes = data.cantidad_total;
                this.filterType = 'normal';
                this.updateDisplayedRoutes();
                
                if (this.search) {
                    this.applySearchFilter();
                }
            } catch (error) {
                console.error('Error al cargar rutas:', error);
            }
        },
        async loadCategories() {
            try {
                const { data } = await axios.get(this.categoryroutes);
                this.categories = data;
            } catch (error) {
                console.error('Error al cargar categorías:', error);
            }
        },
        updateDisplayedRoutes() {
            this.displayedRoutes = this.routes.slice(0, this.itemsToShow);
        },
        handleSearch(searchText) {
            this.search = searchText;
            this.applySearchFilter();
        },
        applySearchFilter() {
            this.filterType = 'input';
            const searchLower = this.search.toLowerCase();
            this.displayedRoutes = this.routes.filter(route => 
                route.name?.toLowerCase().includes(searchLower)
            );
        },
        async handleCategoryFilter() {
            if (this.selectedCategory === 'all') {
                this.itemsToShow = ITEMS_PER_PAGE;
                await this.loadRoutes();
                return;
            }

            try {
                const { data } = await axios.get(`${this.categorysearch}/${this.selectedCategory}`);
                this.routes = data.data;
                this.displayedRoutes = data.data;
                this.totalRoutes = data.cantidad_total;
                this.filterType = 'categoria';
                
                if (this.search) {
                    this.applySearchFilter();
                }
            } catch (error) {
                console.error('Error al filtrar por categoría:', error);
            }
        },
        loadMore() {
            this.itemsToShow += ITEMS_PER_PAGE;
            this.loadRoutes();
        },
        enrollRoute(route) {
            this.$emit('changeStep', {
                step: 2,
                route: route,
                users: this.info.users
            });
        },
        stripHtml(html) {
            return html?.replace(/<[^>]+>/g, '') || '';
        }
    }
};
</script>

<style scoped>
.route-title {
    height: 3.5625rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.short-description-diploma {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.list-courses-description {
    max-height: 10rem;
    overflow-y: auto;
}
</style>